import { render, staticRenderFns } from "./UploaderTftResult.vue?vue&type=template&id=554d68d9&scoped=true&"
import script from "./UploaderTftResult.vue?vue&type=script&lang=js&"
export * from "./UploaderTftResult.vue?vue&type=script&lang=js&"
import style0 from "./UploaderTftResult.vue?vue&type=style&index=0&id=554d68d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d68d9",
  null
  
)

export default component.exports